import { useState } from "react";
import ClearCartModal from "../../../ClearCartModal";
import SvgRemoveFromCart from "./SvgRemoveFromCart";
interface Props {
  cartItemId: number;
}

const ItemRemoveBtn: React.FC<Props> = ({ cartItemId }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <ClearCartModal show={show} setShow={setShow} id={cartItemId} />
      <div className="cart-remove-item-btn" onClick={() => setShow(true)}>
        <SvgRemoveFromCart />
      </div>
    </div>
  );
};

export default ItemRemoveBtn;
